import { ColumnType, FormType, ModalSize, CanActivateFalseGuard } from 'yt-ng-framework';
import { RefreshType } from 'yt-ng-framework';
import { DokumentStavkaModalUpdateComponent } from './dokument/dokument-stavka-modal-update.component';
import { DokumentStavkaView } from './dokument/dokument-stavka-view';
import { DokumentStavkaUpdateComponent } from './dokument/dokument-stavka-update.component';
import { Dokument } from './dokument/dokument';
import { DokumentView } from './dokument/dokument-view';
import { MatComponent } from './mat.component';
import { LookupsRoutes } from './../lookups/routes';
import { NgModule } from "@angular/core";
import { Routes, RouterModule, Router } from "@angular/router";
import { HomeComponent } from "./home/home.component";
import { DokumentTabsComponent } from './dokument/dokument-tabs.component';
import { DokumentStavka } from './dokument/dokument-stavka';
//import { routerNgProbeToken } from '@angular/router/src/router_module';
import { CanDeactivateGuard } from 'yt-ng-framework';
import { KarticaMpArtiklaComponent } from './kartica-mp-artikla/kartica-mp-artikla.component';
import { KarticaMpArtikla } from './kartica-mp-artikla/kartica-mp-artikla';
import { KarticaMpArtiklaUkupnoComponent } from './kartica-mp-artikla/kartica-mp-artikla-ukupno.component';
import { PrometRobeZaKomitentaPoArtiklimaComponent } from './promet-robe-za-komitenta-po-artiklima/promet-robe-za-komitenta-po-artiklima.component';
import { PrometRobeZaKomitentaPoArtiklima } from './promet-robe-za-komitenta-po-artiklima/promet-robe-za-komitenta-po-artiklima';
import { PrometKaseComponent } from './_reports/promet-kase/promet-kase.component';
import { RekapitulacijaIzlazaPoArtiklimaComponent } from './rekapitulacija-izlaza-po-artiklima/rekapitulacija-izlaza-po-artiklima.component';
import { RekapitulacijaIzlazaPoArtiklima } from './rekapitulacija-izlaza-po-artiklima/rekapitulacija-izlaza-po-artiklima';
import { PrometRobeZaKomitentaPoArtiklimaAnalitikaComponent } from './promet-robe-za-komitenta-po-artiklima/promet-robe-za-komitenta-po-artiklima-analitika.component';
import { KarticaMpArtiklaModalComponent } from './kartica-mp-artikla/kartica-mp-artikla-modal.component';
import { PrometRobeZaKomitentaPoArtiklimaUkupnoComponent } from './promet-robe-za-komitenta-po-artiklima/promet-robe-za-komitenta-po-artiklima-ukupno.component';
import { KepComponent } from './_reports/kep/kep.component';

let childrenRoutes: Routes = [
    {
        path: 'home',
        component: HomeComponent
    }
    , {
        path: 'ulazni-dokumenti',
        component: DokumentTabsComponent,
        pathMatch: 'full',
        canDeactivate: [CanDeactivateGuard],
        data: {
            mainList: {
                userRightsModelName:'ulaznidokumenti',
                modelName: 'Dokument',
                getName: 'GetByUrl',
                getParameters: [{ Name: 'url', Value: '/mat/ulazni-dokumenti' }],
                modelClass: Dokument,
                shortModelClass: DokumentView,
                parentProperty: '',
                tableColumns: [
                    { name: 'ID', label: 'ID', visible: false, type: 'number' },
                    { name: 'BrojDokumenta', label: 'DOKUMENT.BROJDOKUMENTA.SINGULAR', visible: true }
                    , { name: 'Datum', label: 'DOKUMENT.DATUM.SINGULAR', type: 'ngbDate', format: 'dd.MM.yyyy', visible: true }
                    , { name: 'KomitentS', label: 'DOKUMENT.KOMITENT.SINGULAR', visible: true }
                    // ,{ name: 'KomitentMesto', label: 'Mesto', visible:true}
                    , { name: 'UkupnoUlaz', label: 'TOTAL.PURCHASE.SINGULAR', visible: true, format: '1.2-2', type: 'number' }
                ],
                sortBy: 'ID',
                sortReverse: true,
                enableEdit: true,
                enableDelete: true,
                formType: 'reactive',
                closeAfterSave: false,
                detailList: [
                    {
                        modelName: 'DokumentStavka',
                        getName: 'getByDokumentID',
                        getParameters: [],
                        modelClass: DokumentStavka,
                        shortModelClass: DokumentStavkaView,
                        tableColumns: [
                            { name: 'Roba', label: 'DOKUMENTSTAVKE.ROBA.SINGULAR', visible: true }
                            , { name: 'Magacin', label: 'DOKUMENTSTAVKE.MAGACIN.SINGULAR', visible: true }
                            , { name: 'Serija', label: 'DOKUMENTSTAVKE.SERIJA.SINGULAR', visible: true }
                            , { name: 'DatumIsteka', label: 'DOKUMENTSTAVKE.DATUMISTEKA.SINGULAR', format: 'dd.MM.yyyy', visible: true, type: 'ngbDate' }
                            , { name: 'Kolicina', label: 'DOKUMENTSTAVKE.KOLICINA.SINGULAR', format: '1.2-2', aligment: 'right', type: 'number', visible: true }
                            , { name: 'NabavnaCena', label: 'DOKUMENTSTAVKE.NABAVNACENA.SINGULAR', format: '1.2-2', aligment: 'right', type: 'number', visible: true }
                            , { name: 'Ukupno', label: 'TOTAL.SINGULAR', format: '1.2-2', aligment: 'right', type: 'number', visible: true }
                        ],
                        sortBy: 'RobaNaziv',
                        sortReverse: false,
                        enableEdit: false,
                        enableDelete: false,
                        parentProperty: 'DokumentID',
                        updateComponent: DokumentStavkaModalUpdateComponent,
                        formType: 'reactive',
                        showOnFirstPage: true
                    }
                ],
                columnClass: 'col-md-4'
            },
            //detailList: [],
            mainTitle: 'dokument',
            updateComponent: null,
            refreshType: RefreshType.NoReload,
            loadOnInit: true
        }
    }
//
, {
    path: 'izlazni-dokumenti',
    component: DokumentTabsComponent,
    pathMatch: 'full',
    canDeactivate: [CanDeactivateGuard],
    data: {
        mainList: {
            userRightsModelName:'izlaznidokumenti',
            modelName: 'Dokument',
            getName: 'GetByUrl',
            getParameters: [{ Name: 'url', Value: '/mat/izlazni-dokumenti' }],
            modelClass: Dokument,
            shortModelClass: DokumentView,
            parentProperty: '',
            tableColumns: [
                { name: 'ID', label: 'ID', visible: false, type: 'number' },
                { name: 'BrojDokumenta', label: 'DOKUMENT.BROJDOKUMENTA.SINGULAR', visible: true }
                , { name: 'Datum', label: 'DOKUMENT.DATUM.SINGULAR', type: 'ngbDate', format: 'dd.MM.yyyy', visible: true }
                , { name: 'KomitentS', label: 'DOKUMENT.KOMITENT.SINGULAR', visible: true }
                // ,{ name: 'KomitentMesto', label: 'Mesto', visible:true}
                , { name: 'UkupnoIzlaz', label: 'TOTAL.PURCHASE.SINGULAR', visible: true, format: '1.2-2', type: 'number' }
            ],
            sortBy: 'ID',
            sortReverse: true,
            enableEdit: true,
            enableDelete: true,
            formType: 'reactive',
            closeAfterSave: false,
            detailList: [
                {
                    modelName: 'DokumentStavka',
                    getName: 'getByDokumentID',
                    getParameters: [],
                    modelClass: DokumentStavka,
                    shortModelClass: DokumentStavkaView,
                    tableColumns: [
                        { name: 'Roba', label: 'DOKUMENTSTAVKE.ROBA.SINGULAR', visible: true }
                        , { name: 'Magacin', label: 'DOKUMENTSTAVKE.MAGACIN.SINGULAR', visible: true }
                        , { name: 'Serija', label: 'DOKUMENTSTAVKE.SERIJA.SINGULAR', visible: true }
                        , { name: 'DatumIsteka', label: 'DOKUMENTSTAVKE.DATUMISTEKA.SINGULAR', format: 'dd.MM.yyyy', visible: true, type: 'ngbDate' }
                        , { name: 'Kolicina', label: 'DOKUMENTSTAVKE.KOLICINA.SINGULAR', format: '1.2-2', aligment: 'right', type: 'number', visible: true }
                        , { name: 'NabavnaCena', label: 'DOKUMENTSTAVKE.NABAVNACENA.SINGULAR', format: '1.2-2', aligment: 'right', type: 'number', visible: true }
                        , { name: 'Ukupno', label: 'TOTAL.SINGULAR', format: '1.2-2', aligment: 'right', type: 'number', visible: true }
                    ],
                    sortBy: 'RobaNaziv',
                    sortReverse: false,
                    enableEdit: false,
                    enableDelete: false,
                    parentProperty: 'DokumentID',
                    updateComponent: DokumentStavkaModalUpdateComponent,
                    formType: 'reactive',
                    showOnFirstPage: true
                }
            ],
            columnClass: 'col-md-4'
        },
        //detailList: [],
        mainTitle: 'dokument',
        updateComponent: null,
        refreshType: RefreshType.NoReload,
        loadOnInit: true
    }
}

//
    , {
        path: 'kartica-mp-artikla',
        component: KarticaMpArtiklaComponent,
        pathMatch: 'full',
        data: {
            mainList: {
                printName: 'printaj',
                modelName: 'karticampartikla',
                getName: 'GetByPeriodRobaAndKomitent',
                getParameters: [],
                modelClass: KarticaMpArtikla,
                parentProperty: '',
                tableColumns: [
                    { name: 'Datum', label: 'KARTICAMPARTIKLA.DATUM.SINGULAR', visible: true, canHide: false, type: 'ngbDate', format: 'dd.MM.yyyy'  }
                    , { name: 'BrDok', label: 'KARTICAMPARTIKLA.BRDOK.SINGULAR', visible: true, canHide: false}
                    , { name: 'KomitentNaziv', label: 'KARTICAMPARTIKLA.KOMITENTNAZIV.SINGULAR', visible: true, canHide: false}
                    , { name: 'Ulaz', label: 'KARTICAMPARTIKLA.ULAZ.SINGULAR', visible: true, canHide: false, type: 'number' }
                    , { name: 'Izlaz', label: 'KARTICAMPARTIKLA.IZLAZ.SINGULAR', visible: true, canHide: false, type: 'number' }
                    , { name: 'Stanje', label: 'KARTICAMPARTIKLA.STANJE.SINGULAR', visible: true, canHide: false, type: 'number' }
                    , { name: 'CenaDob', label: 'KARTICAMPARTIKLA.CENADOB.SINGULAR', visible: true, canHide: false, type: 'number' }
                    , { name: 'CenaNab', label: 'KARTICAMPARTIKLA.CENANAB.SINGULAR', visible: true, canHide: false, type: 'number' }
                    , { name: 'CenaProd', label: 'KARTICAMPARTIKLA.CENAPROD.SINGULAR', visible: true, canHide: false, type: 'number' }
                ],
                sortBy: '',
                sortReverse: false,
                enableEdit: false,
                enableDelete: false,
                formType: FormType.Reactive,
                defaultPropertyName: 'ID',
                enablePrint: false
            },
            mainTitle: 'Kartica MP artikla',
            modalSize: ModalSize.Md,
            refreshType: RefreshType.NoReload,
            loadOnInit: false,
            breadcrumbLabel: 'KARTICAMPARTIKLA.SINGULAR'
        }
    }
    , {
        path: 'kartica-mp-artikla-ukupno',
        component: KarticaMpArtiklaUkupnoComponent,
        pathMatch: 'full',
        canDeactivate: [CanDeactivateGuard],
        data: {
            mainList: {
                modelName: 'karticampartikla',
                getName: 'get',
                getParameters: [],
                modelClass: KarticaMpArtikla,
                shortmodelClass: KarticaMpArtikla,
                parentProperty: '',
                tableColumns: [
                ],
                sortBy: '',
                sortReverse: false,
                enableEdit: false,
                enableDelete: false,
                formType: FormType.Reactive,
                detailList: [
                ],
                defaultPropertyName: 'ID'
            },
            mainTitle: 'UKUPNO - ANALIZA',
            modalSize: ModalSize.Md,
            refreshType: RefreshType.NoReload,
            loadOnInit: true,
            breadcrumbLabel: 'KARTICAMPARTIKLA.SINGULAR',
            updateComponent: KarticaMpArtiklaUkupnoComponent
        }
    }
    , {
        path: 'promet-robe-za-komitenta-po-artiklima',
        component: PrometRobeZaKomitentaPoArtiklimaComponent,
        pathMatch: 'full',
        data: {
            mainList: {
                printName: 'printaj',
                modelName: 'PrometRobeZaKomitentaPoArtiklima',
                getName: 'GetByPeriodAndKomitent',
                getParameters: [],
                modelClass: PrometRobeZaKomitentaPoArtiklima,
                parentProperty: '',
                tableColumns: [
                    { name: 'RobaSifra', label: 'PROMETROBEZAKOMITENTAPOARTIKLIMA.ROBASIFRA.SINGULAR', visible: true, canHide: false }
                    , { name: 'RobaNaziv', label: 'PROMETROBEZAKOMITENTAPOARTIKLIMA.ROBANAZIV.SINGULAR', visible: true, canHide: false }
                    , { name: 'RobaJm', label: 'PROMETROBEZAKOMITENTAPOARTIKLIMA.ROBAJM.SINGULAR', visible: true, canHide: false }
                    , { name: 'Ulaz', label: 'PROMETROBEZAKOMITENTAPOARTIKLIMA.ULAZ.SINGULAR', visible: true, canHide: false, type: 'number' }
                    , { name: 'Izlaz', label: 'PROMETROBEZAKOMITENTAPOARTIKLIMA.IZLAZ.SINGULAR', visible: true, canHide: false, type: 'number' }
                ],
                sortBy: '',
                sortReverse: false,
                enableEdit: false,
                enableDelete: false,
                formType: FormType.Reactive,
                defaultPropertyName: 'RobaNaziv'
            },
            mainTitle: 'Promet robe za komitenta po artiklima',
            modalSize: ModalSize.Md,
            refreshType: RefreshType.NoReload,
            loadOnInit: false,
            breadcrumbLabel: 'PROMETROBEZAKOMITENTAPOARTIKLIMA.SINGULAR'
        }
    }
    , {
        path: 'promet-kase',
        component: PrometKaseComponent,
        pathMatch: 'full',
        data: {
            mainList: {
                modelName: 'VmatReports',
                printName: 'PrintajPrometKasePoKorisnicima',
                tableColumns: [
                    { name: 'Naziv', label: 'PROMETKASE.SINGULAR', visible: true, canHide: false }  
                ],
            },
            mainTitle: 'Promet kase',            
            breadcrumbLabel: 'PROMETKASE.SINGULAR'
        }
    }
    , {
        path: 'rekapitulacija-izlaza-po-artiklima',
        component: RekapitulacijaIzlazaPoArtiklimaComponent,
        pathMatch: 'full',
        data: {
            mainList: {
                modelName: 'rekapitulacijaizlazapoartiklima',
                printName: 'PrintajRekapitulacijuIzlazaPoArtiklima',             
                tableColumns: [
                    {name: 'Naziv', label:'REKAPITULACIJAIZLAZAPOARTIKLIMA.NAZIV', visible: true, canHide: false }
                  ],                
            },
            mainTitle: 'Rekapitulacija izlaza po artiklima',            
            breadcrumbLabel: 'REKAPITULACIJAIZLAZAPOARTIKLIMA.SINGULAR'
        }
    }
    , {
        path: 'promet-robe-po-artiklima-analitika',
        component: PrometRobeZaKomitentaPoArtiklimaAnalitikaComponent,
        pathMatch: 'full',
        data: {
            mainList: {
                modelName: 'karticampartikla',
                getName: 'get',
                getParameters: [],
                modelClass: KarticaMpArtikla,
                tableColumns: [
                    { name: 'Ulaz', label: 'PROMETROBEZAKOMITENTAPOARTIKLIMA.ULAZ.SINGULAR', visible: true, canHide: false, type: 'number' }
                    , { name: 'Izlaz', label: 'PROMETROBEZAKOMITENTAPOARTIKLIMA.IZLAZ.SINGULAR', visible: true, canHide: false, type: 'number' }
                ],
            },
            mainTitle: 'Promet kase',
            breadcrumbLabel: 'PROMETKASE.SINGULAR'
        }
    }

    , {
        path: 'kartica-mp-artikla-modal',
        component: KarticaMpArtiklaModalComponent,
        pathMatch: 'full',
        canActivate: [CanActivateFalseGuard],
        data: {
            mainList: {
                modelName: 'karticampartikla',
                getName: 'GetByPeriodRobaAndKomitent',
                getParameters: [],
                modelClass: KarticaMpArtikla,
                parentProperty: '',
                tableColumns: [
                    { name: 'Datum', label: 'KARTICAMPARTIKLA.DATUM.SINGULAR', visible: true, canHide: false, type: 'ngbDate', format: 'dd.MM.yyyy'  }
                    , { name: 'KomitentNaziv', label: 'KARTICAMPARTIKLA.KOMITENTNAZIV.SINGULAR', visible: true, canHide: false}
                    , { name: 'Ulaz', label: 'KARTICAMPARTIKLA.ULAZ.SINGULAR', visible: true, canHide: false, type: 'number' }
                    , { name: 'Izlaz', label: 'KARTICAMPARTIKLA.IZLAZ.SINGULAR', visible: true, canHide: false, type: 'number' }
                    , { name: 'Stanje', label: 'KARTICAMPARTIKLA.STANJE.SINGULAR', visible: true, canHide: false, type: 'number' }
                    , { name: 'CenaDob', label: 'KARTICAMPARTIKLA.CENADOB.SINGULAR', visible: true, canHide: false, type: 'number' }
                    , { name: 'CenaNab', label: 'KARTICAMPARTIKLA.CENANAB.SINGULAR', visible: true, canHide: false, type: 'number' }
                    , { name: 'CenaProd', label: 'KARTICAMPARTIKLA.CENAPROD.SINGULAR', visible: true, canHide: false, type: 'number' }
                ],
                sortBy: '',
                sortReverse: false,
                enableEdit: false,
                enableDelete: false,
                formType: FormType.Reactive,
                defaultPropertyName: 'ID',
                enablePrint: false
            },
            mainTitle: 'Kartica MP artikla',
            modalSize: ModalSize.Lg,
            refreshType: RefreshType.NoReload,
            loadOnInit: false,
            breadcrumbLabel: 'KARTICAMPARTIKLA.SINGULAR',
            updateComponent: KarticaMpArtiklaModalComponent,

        }
    }

    , {
        path: 'promet-robe-za-komitenta-po-artiklima-ukupno',
        component: PrometRobeZaKomitentaPoArtiklimaUkupnoComponent,
        pathMatch: 'full',
        canActivate: [CanActivateFalseGuard],
        data: {
            mainList: {
                modelName: 'PrometRobeZaKomitentaPoArtiklima',
                getName: 'GetByPeriodAndKomitent',
                getParameters: [],
                modelClass: PrometRobeZaKomitentaPoArtiklima,
                parentProperty: '',
                tableColumns: [
                ],
                sortBy: '',
                sortReverse: false,
                enableEdit: false,
                enableDelete: false,
                formType: FormType.Reactive,
                defaultPropertyName: 'ID',
                enablePrint: false
            },
            mainTitle: 'Kartica komitenta - ukupno',
            modalSize: ModalSize.Lg,
            refreshType: RefreshType.NoReload,
            loadOnInit: false,
            breadcrumbLabel: 'PROMETROBEZAKOMITENTAPOARTIKLIMA.SINGULAR',
            updateComponent: PrometRobeZaKomitentaPoArtiklimaUkupnoComponent,
        }
    }
    , {
        path: 'kep',
        component: KepComponent,
        pathMatch: 'full',
        data: {
            mainList: {
                modelName: 'VmatReports',
                printName: 'PrintajKep',
                tableColumns: [
                    { name: 'Naziv', label: 'KEP.SINGULAR', visible: true, canHide: false }
                ],
            },
            mainTitle: 'Knjiga evidencija prometa',
            breadcrumbLabel: 'KEP.SINGULAR'
        }
    }

];

childrenRoutes = childrenRoutes.concat(LookupsRoutes);

const routes: Routes = [
    {
        path: '',
        component: MatComponent,
        children: childrenRoutes
        //data: {
        //breadcrumbLabel: 'mat'
        //}
    }

]
@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class MatRoutingModule {
    // constructor(private router: Router) {
    //     //this.router.resetConfig(routes);
    // }
}